// extracted by mini-css-extract-plugin
export default {"RMSGalleryBlock":"RMSGalleryBlock_RMSGalleryBlock__dlxID","Inner":"RMSGalleryBlock_Inner__-PUy7","ImgContainer":"RMSGalleryBlock_ImgContainer__0Bu2j"};